import { EFilterBySyncChatSchema, EStatusSyncChatSchema } from '../../types/chatList';
import { ERoute, TRoute } from '../../types/route';

export const getQueryParamsFetchChatsList = (currentRoute: TRoute) => {
  let filterBy;
  let status;
  switch (currentRoute) {
    case ERoute.Messages:
      status = EStatusSyncChatSchema.Active;
      break;
    case ERoute.Archive:
      status = EStatusSyncChatSchema.Archived;
      break;
    case ERoute.Spam:
      status = EStatusSyncChatSchema.Blocked;
      break;
    case ERoute.Starred:
      filterBy = EFilterBySyncChatSchema.Starred;
      status = EStatusSyncChatSchema.Active;
      break;
    case ERoute.Unread:
      filterBy = EFilterBySyncChatSchema.Unread;
      status = EStatusSyncChatSchema.Active;
      break;
    default:
      status = EStatusSyncChatSchema.Active;
  }

  return { filterBy, status };
};
